<template>
  <div
    class="parent-container"
  >
    <v-flex
      class="btn-div"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    >
      <span
        class="btn-name"
        :class="(hover || focus) ? 'btn-name-shrink' : ''"
      >
        給油登録
      </span>
      <NumberField
        ref="numField"
        v-model="customerSupply"
        class="numberField"
        :class="(hover || focus) ? '' : 'numberField-shrink'"
        single-line
        background-color="white"
        suffix="ℓ"
        append-icon="mdi-send"
        :min="1"
        :max="9999"
        color="transparent"
        height="45"
        label="給油量"
        @focus="focus = true"
        @blur="focus = false"
        @click:append="sendCustomerSupply"
        @keyup.enter="sendCustomerSupply"
      />
    </v-flex>
    <v-menu
      :value="(hover || focus)"
      top
      nudge-bottom="45"
      nudge-left="25"
      :close-on-content-click="false"
      :close-on-click="false"
      allow-overflow
      attach=".btn-div"
    >
      <v-list>
        <v-list-tile>
          <v-menu
            nudge-left="180"
            lazy
            origin="top right"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-icon
                medium
                class="px-1"
                @click.prevent="changeDateHandler(-1)"
              >
                mdi-menu-left
              </v-icon>
              <v-text-field
                :value="date.split('-').slice(1).join('月') + '日'"
                class="date-field"
                readonly
                @focus="focus = true"
                @blur="numField.focus()"
                @keydown.esc.stop
                @keydown.tab.stop
                v-on="on"
              />
              <v-icon
                medium
                class="px-1"
                :style="`opacity:${date === tdyDate? 0 : 1}`"
                :disabled="date === tdyDate"
                @click="changeDateHandler(1)"
              >
                mdi-menu-right
              </v-icon>
            </template>
            <v-date-picker
              v-model="date"
              color="metalBlue"
              locale="ja-JP"
              type="date"
              :day-format="dateFormat"
              show-current
              :max="tdyDate"
            />
          </v-menu>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import NumberField from './NumberField.vue'
import { obj2fullDate } from '@/utils/time.js'

export default {
  components: {
    NumberField
  },
  props: {
    id: {
      type: Number,
      default: () => null
    },
    code: {
      type: String,
      default: () => ''
    },
    initList: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 10),
      tdyDate: new Date().toISOString().substr(0, 10),
      customerSupply: null,
      hover: false,
      focus: false
    }
  },
  computed: {
    timeStamp () {
      return new Date(this.date).setHours(0, 0, 0, 0) / 1000
    },
    numField () {
      return this.$refs.numField.$refs.numField
    }
  },
  watch: {
    id () {
      this.customerSupply = null
    }
  },
  methods: {
    dateFormat (e) {
      return Number(e.split('-')[2])
    },
    changeDateHandler (offset) {
      let date = new Date(this.date)
      date.setDate(date.getDate() + offset)
      this.date = obj2fullDate(date).split('/').join('-')
    },
    async sendCustomerSupply () {
      if (!this.id || (this.customerSupply < 1 || this.customerSupply > 9999)) {
        return
      }

      const body = {
        timestamp: this.timeStamp,
        amount: this.customerSupply
      }

      await this.$store.dispatch('customers/sendCustomerSupply', { body, id: this.id, initList: this.initList })
      this.$store.commit('app/setGlobalSnackBarText', `顧客(顧客番号: ${this.code})に${this.customerSupply}ℓ給油しました。`)
      this.customerSupply = null
      this.blurAway()
    },
    blurAway () {
      this.numField.blur()
    }
  }
}
</script>

<style lang="scss" scoped>
.parent-container{
  position: relative;
  display: flex;
  justify-content: flex-end;
}
/deep/.btn-div{
    color: white;
    height: 36px;
    width: 95px;
    margin-top: 10px;
    padding: 2px!important;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    border-radius: 7px;
    background: var(--metal-orange);
    position: absolute;
    .v-menu__content{
      height: 100px;
      width: 150px;
      border: 2px var(--metal-orange) solid!important;
      z-index: 0!important;
      background: white;
    }
}
/deep/.numberField{
  opacity: 1;
  transition: opacity 0.2s;
  .v-input__slot{
    width: 130px;
    border-radius: 5px!important;
    margin-bottom: 4px;
    padding-left: 35px;
    caret-color: var(--metal-orange)!important;
    .v-text-field__suffix{
      color: var(--metal-orange);
    }
    &:before{
      display: none;
    }
  }
  .v-text-field__slot .v-label{
    font-size: 0.8rem;
  }
  &-shrink{
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
  }
}
/deep/.v-text-field .v-input__append-inner{
    margin-top: 10px;
}
.btn-name{
  position: absolute;
  opacity: 1;
  transition: opacity 0.2s;
  &-shrink{
    opacity: 0;
    transition: 0.2s
  }
}
/deep/.theme--light.v-icon{
  cursor: pointer;
  font-size: 1.2rem;
  color: var(--metal-orange)!important;
  transition: 0.2s;
  &:hover{
    transition: 0.2s;
    color: #a06000!important;
  }
}
/deep/.v-text-field.v-text-field--enclosed .v-text-field__details{
  display: none;
}
/deep/.v-menu__content{
  max-width: 150%;
}
/deep/.theme--light.v-list{
  padding: 0;
}
/deep/.v-list__tile{
  padding: 0;
}
/deep/.mdi-menu-left::before, /deep/.mdi-menu-right::before{
  color: black;
}
/deep/.date-field{
  &.v-input input{
    text-align: center;
    cursor: pointer;
    transition: 0.3s;
    &:hover{
      background: rgba(128, 128, 128, 0.096);
      transition: 0.3s;
    }
  }
}
/deep/.v-date-picker-table .v-btn{
  padding: 20px;
}
/deep/.v-date-picker-table{
  height: auto;
  padding-bottom: 10px;
}
/deep/.v-picker__title__btn:not(.v-picker__title__btn--active), /deep/.theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus){
  pointer-events: none;
}
</style>
